import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowRightIcon, CalendarDaysIcon, CheckIcon, LeafIcon, ListChecksIcon, MonitorSmartphoneIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const learningPoints = ['Cómo comer mejor sin volver a empezar cada lunes.', 'Cómo alejarte de las dietas que no encajan con tu vida.', 'Cómo armar platos equilibrados con alimentos cotidianos.', 'Cómo organizar tus comidas sin pasar horas planificando.', 'Cómo cocinar opciones que te den ganas de repetir.', 'Cómo usar Meal Prep para ganar tiempo durante la semana.', 'Cómo crear hábitos que se adapten a tu ritmo.', 'Cómo construir una forma de comer que puedas sostener a largo plazo.', 'Cómo disfrutar tus comidas sin culpa ni restricciones innecesarias.', 'Cómo tomar decisiones más conscientes para tu bienestar.'];
export function HeroSystem() {
  return <>
      <section id="inicio" className="relative overflow-hidden bg-[#f5f4ed]" data-id="element-88" data-mp="l0qslldk9ob5">
        <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=2200&q=85" alt="Cocina moderna iluminada por luz natural" className="absolute inset-0 h-full w-full object-cover opacity-[0.20]" data-id="element-89" data-mp="kynsg8ip2esp" />
        <div className="relative mx-auto grid min-h-[760px] max-w-7xl items-center gap-12 px-5 pb-28 pt-16 sm:px-8 sm:py-16 lg:grid-cols-[1fr_1.05fr] lg:py-24" data-id="element-90" data-mp="64j6ugmi8etr">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="order-2 max-w-2xl lg:order-1" data-id="element-91" data-mp="ysf4bnjwearl">
            <p className="mb-6 text-xs font-bold tracking-[0.2em] text-[#6f8061]" data-id="element-92" data-mp="1mirkflpardt9">
              UNA FORMA REALISTA DE COMER MEJOR
            </p>
            <h1 className="font-display text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl lg:text-6xl" data-id="element-93" data-mp="1howui0j3m2lq">
              Deja de empezar de cero y aprende a alimentarte bien{' '}
              <em className="font-normal" data-id="element-94" data-mp="3gxewwb2fdfp6">de una vez por todas.</em>
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-8 text-[#606b5d]" data-id="element-95" data-mp="3288xalzodngr">
              Hábitos para una Vida Saludable te acompaña paso a paso para que
              sepas qué comer, qué cocinar y cómo crear una rutina que sí encaje
              con tus días, sin castigos ni planes imposibles de sostener.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-96" data-mp="2xba2s2c3nei1">
              <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white transition-colors hover:bg-[#30452e]" data-id="element-97" data-mp="2jb7o0oz39170">
                QUIERO COMENZAR MI CAMBIO{' '}
                <ArrowRightIcon className="ml-2" size={17} data-id="element-98" data-mp="26zyb6tbazrgm" />
              </a>
              <a href="#incluye" className="inline-flex min-h-14 items-center justify-center rounded-full border border-[#758171] bg-white/70 px-7 text-sm font-semibold text-[#40503d] transition-colors hover:bg-white" data-id="element-99" data-mp="26xua0j4sh6k1">
                Conocer el sistema completo{' '}
                <ArrowDownIcon className="ml-2" size={16} data-id="element-100" data-mp="2bx6xn63hihno" />
              </a>
            </div>
            <div className="mt-9 flex flex-wrap gap-x-6 gap-y-3 text-xs text-[#52604e]" data-id="element-101" data-mp="2ps9ayeanv9ai">
              <span className="flex items-center gap-1 text-[#9c7428]" data-id="element-102" data-mp="2ktft69occw4j">
                <StarIcon fill="currentColor" size={15} data-id="element-103" data-mp="2znavewtzrn6r" />
                <StarIcon fill="currentColor" size={15} data-id="element-104" data-mp="2upsplfb9to2z" />
                <StarIcon fill="currentColor" size={15} data-id="element-105" data-mp="2uqaoykt8cif4" />
                <StarIcon fill="currentColor" size={15} data-id="element-106" data-mp="159t9fe98iydu" />
                <StarIcon fill="currentColor" size={15} data-id="element-107" data-mp="15cfp616a4k75" />
              </span>
              <span data-id="element-108" data-mp="10dci6b6qo3wj">Planes para la vida real</span>
              <span data-id="element-109" data-mp="3nkh0e3iaqpbw">Acceso inmediato</span>
              <span data-id="element-110" data-mp="3njpfbmmbs9zv">Todos tus dispositivos</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="relative order-1 mx-auto w-full max-w-xl lg:order-2" data-id="element-111" data-mp="3shh62db8hq2h">
            <div className="absolute -inset-5 bg-[#e4e4d5]/75" data-id="element-112" data-mp="39tlw74iqswen" />
            <img src="https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1100&q=85" alt="Ingredientes naturales sobre mesa de madera clara" className="relative h-[390px] w-full object-cover sm:h-[500px]" data-id="element-113" data-mp="3due7s4f37de3" />
            <div className="absolute inset-x-[10%] bottom-[-15px] flex items-end justify-center gap-2 sm:gap-4" data-id="element-114" data-mp="2q4jujlquvmtb">
              {[['HÁBITOS PARA UNA\nVIDA SALUDABLE', 'text-[#f8f5e9] bg-[#405a3b]'], ['DÉFICIT\nCALÓRICO', 'text-[#354a35] bg-[#d9ded0]'], ['COCINA\nANTIINFLAMATORIA', 'text-[#705f41] bg-[#eadfc8]'], ['PLANIFICADOR', 'text-[#fffdf6] bg-[#536a54]']].map(([title, colors], index) => <div key={title} className={`${colors} flex w-20 items-center justify-center px-1.5 py-3 text-center shadow-xl sm:w-28 sm:px-3 sm:py-7 ${index === 0 ? 'h-36 sm:h-48' : 'h-28 sm:h-40'}`} data-id="element-115" data-mp="24ndsh770o1uv" data-mpi={index}>
                  <span className="block w-full break-words text-[7px] font-bold leading-[1.35] tracking-[0.08em] sm:text-[10px] sm:leading-4 sm:tracking-[0.12em]" data-id="element-116" data-mp="1pxesqzztcida">
                    {title}
                    <span className="mt-2 block text-[6px] font-medium leading-[1.3] tracking-normal sm:text-[9px]" data-id="element-117" data-mp="1gune6rbn56hf">
                      CÓDIGO FITNESS™
                    </span>
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </section>

      <section id="sistema" className="relative overflow-hidden bg-[#fffefa] py-24 sm:py-32" data-id="element-118" data-mp="178uil31qqfgg">
        <LeafIcon aria-hidden="true" className="absolute -left-8 top-24 h-28 w-28 rotate-[22deg] text-[#dce7d4]/55" strokeWidth={1} data-id="element-119" data-mp="scn1iblmpu5e" />
        <LeafIcon aria-hidden="true" className="absolute -right-5 bottom-28 h-32 w-32 -rotate-[35deg] text-[#e4eadc]/70" strokeWidth={1} data-id="element-120" data-mp="1l0ivv9nq79z0" />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-121" data-mp="1ba7t3qfs36tp">
          <div className="grid gap-16 lg:grid-cols-[.82fr_1.18fr] lg:items-center lg:gap-20" data-id="element-122" data-mp="1b7twve9d3okk">
            <motion.figure initial={{
            opacity: 0,
            y: 18,
            rotate: -1
          }} whileInView={{
            opacity: 1,
            y: 0,
            rotate: -3
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.65
          }} className="relative mx-auto w-full max-w-[430px] lg:max-w-none" data-id="element-123" data-mp="1g6oh8kmz9l6s">
              <div aria-hidden="true" className="absolute inset-x-8 bottom-0 h-12 rounded-full bg-[#6d7c61]/20 blur-2xl" data-id="element-124" data-mp="20jlcbpnl9n7" />
              <img src="https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png" alt="Portada de la guía Hábitos para una Vida Saludable" className="relative w-full rounded-sm shadow-[18px_28px_42px_rgba(47,59,43,0.28)]" data-id="element-125" data-mp="35hiav1bv5q92" />
            </motion.figure>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.6,
            delay: 0.08
          }} data-id="element-126" data-mp="yphh9x953dly">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-127" data-mp="2y4j1e3jyinfd">
                TODO EMPIEZA CON UN PLAN CLARO
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl" data-id="element-128" data-mp="36xnqe33vlu2e">
                Mucho más que un libro: una guía para dejar de vivir a dieta.
              </h2>

              <div className="mt-7 max-w-3xl space-y-5 text-[15px] leading-7 text-[#63705f] sm:text-base" data-id="element-129" data-mp="3gy6hnixrscuc">
                <p data-id="element-130" data-mp="3lvg3kolya6df">
                  Hábitos para una Vida Saludable no fue creado para imponerte
                  otra dieta que abandonarás en unas semanas.
                </p>
                <p data-id="element-131" data-mp="1riynq23fy8it">
                  Es un sistema práctico para cuando no sabes qué cocinar, tienes
                  poco tiempo o sientes que siempre vuelves a empezar el lunes.
                </p>
                <p data-id="element-132" data-mp="3v1b0c30kgs1">
                  Aprenderás a elegir mejor, organizarte con menos esfuerzo y
                  preparar comidas que disfrutes sin sentir que estás renunciando
                  a todo.
                </p>
                <p data-id="element-133" data-mp="3r2mxicb91ty5">
                  Porque el objetivo no es hacerlo perfecto: es construir hábitos
                  que puedas llevar contigo durante años.
                </p>
              </div>

              <div className="mt-8" data-id="element-134" data-mp="nkuwy9j1s1oc">
                <p className="mb-3 text-sm font-medium text-[#61725b]" data-id="element-135" data-mp="ikqewf2hqyw0">
                  Acceso completo por{' '}
                  <span className="font-display text-2xl text-[#354a33]" data-id="element-136" data-mp="dmf9cgj8bajl">
                    $29.99 USD
                  </span>
                </p>
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)]" data-id="element-137" data-mp="33ciqrw2rle2x">
                  🍃 QUIERO COMENZAR MI TRANSFORMACIÓN
                </a>
                <p className="mt-3 text-xs text-[#70806b]" data-id="element-138" data-mp="bgcadgydsx5b">
                  🔒 Pago seguro • Acceso inmediato • Descarga digital
                </p>
              </div>

              <div className="mt-10 border-t border-[#dbe0d4] pt-8" data-id="element-139" data-mp="k9xqp4q72mgu">
                <div className="flex items-start gap-4" data-id="element-140" data-mp="z89l14q3hj4u">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#e5eddf] text-[#4e6748]" data-id="element-141" data-mp="z5x2apcij4qq">
                    <LeafIcon size={20} strokeWidth={1.5} data-id="element-142" data-mp="30yur8a365d6e" />
                  </span>
                  <div data-id="element-143" data-mp="2w09skf3kf1k2">
                    <h3 className="font-display text-2xl text-[#354a33]" data-id="element-144" data-mp="2w11nrot92x9t">
                      Hábitos para una Vida Saludable
                    </h3>
                    <p className="mt-2 font-medium text-[#52634d]" data-id="element-145" data-mp="1bkbx7gaieg3c">
                      Más de 55 páginas para guiar tus próximos pasos.
                    </p>
                    <p className="mt-3 max-w-2xl leading-7 text-[#657160]" data-id="element-146" data-mp="11rmq0xlzrodt">
                      Una guía clara para transformar tu alimentación de forma
                      práctica, disfrutable y sostenible.
                    </p>
                  </div>
                </div>

                <h4 className="mt-9 text-sm font-bold uppercase tracking-[0.14em] text-[#455b40]" data-id="element-147" data-mp="wtl7cdsh9r2v">
                  Lo que aprenderás
                </h4>
                <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-148" data-mp="ivwmh5yeujxt">
                  {learningPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-sm leading-6 text-[#5b6858]" data-id="element-149" data-mp="2d7umqieqs5hk">
                      <CheckIcon className="mt-1 shrink-0 text-[#69845f]" size={15} strokeWidth={2} data-id="element-150" data-mp="2i4bl05fno08d" />
                      <span data-id="element-151" data-mp="2bss6ocy4bcfr">{point}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>

          <div className="mx-auto mt-20 max-w-5xl border-l-2 border-[#859c78] bg-[#eff3e9] px-7 py-8 sm:px-10 sm:py-9" data-id="element-152" data-mp="21tjdvnezo3uz">
            <div className="flex items-start gap-4" data-id="element-153" data-mp="2zf8hxohlkvtm">
              <LeafIcon className="mt-0.5 shrink-0 text-[#627a58]" size={24} strokeWidth={1.5} aria-hidden="true" data-id="element-154" data-mp="2ugnc99jktjxs" />
              <p className="font-display max-w-4xl text-2xl leading-8 text-[#3e5439] sm:text-[27px]" data-id="element-155" data-mp="2krn9rg5v86eu">
                No necesitas hacerlo perfecto ni depender de más fuerza de
                voluntad. Necesitas una forma clara de volver a elegirte cada
                día. Eso es Hábitos para una Vida Saludable.
              </p>
            </div>
          </div>

          <div className="mt-16 grid border-y border-[#dfe4d8] sm:grid-cols-2 lg:grid-cols-4" data-id="element-156" data-mp="3lqry8d1m7ylz">
            {[['Ideas reales', 'para tus comidas diarias', ListChecksIcon], ['55+', 'páginas de guía práctica', LeafIcon], ['30 días', 'para comenzar con estructura', CalendarDaysIcon], ['4 semanas', 'de menús para orientarte', CalendarDaysIcon], ['Paso a paso', 'sin complicarte en la cocina', CheckIcon], ['Listas', 'para comprar con intención', ListChecksIcon], ['Inmediato', 'acceso a tu sistema', CheckIcon], ['En todos lados', 'celular, tablet y computadora', MonitorSmartphoneIcon]].map(([value, label, Icon], index) => {
            const StatIcon = Icon as typeof LeafIcon;
            return <div key={label as string} className={`min-h-36 p-6 sm:p-7 ${index < 4 ? 'border-b border-[#dfe4d8] lg:border-b-0' : ''} ${index % 2 === 0 ? 'sm:border-r sm:border-[#dfe4d8] lg:border-r' : 'lg:border-r'} ${index === 3 || index === 7 ? 'lg:border-r-0' : ''}`} data-id="element-157" data-mp="w53mtp5fjohs" data-mpi={index}>
                  <StatIcon className="text-[#6d8662]" size={21} strokeWidth={1.4} data-id="element-158" data-mp="1xp1qa58snq8l" />
                  <p className="font-display mt-5 text-2xl text-[#3d5438]" data-id="element-159" data-mp="1a1tvih8zrzkt">
                    {value as string}
                  </p>
                  <p className="mt-1 text-sm leading-5 text-[#6a7567]" data-id="element-160" data-mp="1j16x6nqvjjuz">
                    {label as string}
                  </p>
                </div>;
          })}
          </div>

          <div className="mx-auto mt-16 max-w-4xl text-center" data-id="element-161" data-mp="2ufawm9g8e07f">
            <p className="font-display text-2xl leading-9 text-[#40513e] sm:text-3xl" data-id="element-162" data-mp="2uhorah701aeg">
              Una guía a la que volverás cuando no sepas qué cocinar, cuando la
              semana se complique o cuando quieras retomar tu bienestar.
            </p>
            <p className="mt-6 text-base leading-7 text-[#667361]" data-id="element-163" data-mp="32xw7eiu3duii">
              No es contenido para guardar y olvidar. Es una herramienta para
              tomar mejores decisiones, una comida a la vez.
            </p>
          </div>
        </div>
      </section>
    </>;
}